"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.releaseDistributionRequest = exports.listWaitingForCompany = exports.getDistributionRequest = exports.listDistributionRequests = void 0;
const ApiClient_1 = require("../ApiClient");
const listDistributionRequests = (filters) => {
    const params = new URLSearchParams();
    if (filters.status)
        params.set('status', filters.status);
    if (filters.producer)
        params.set('producer', filters.producer);
    if (filters.ticker)
        params.set('ticker', filters.ticker);
    if (filters.page)
        params.set('page', String(filters.page));
    const query = params.toString();
    return ApiClient_1.apiClient.get(`/api/distribution-requests${query ? `?${query}` : ''}`);
};
exports.listDistributionRequests = listDistributionRequests;
const getDistributionRequest = (requestId) => ApiClient_1.apiClient.get(`/api/distribution-requests/${encodeURIComponent(requestId)}`);
exports.getDistributionRequest = getDistributionRequest;
// Reports refused while their company had the AI type OFF, now ON.
const listWaitingForCompany = () => ApiClient_1.apiClient.get('/api/distribution-requests/waiting-for-company');
exports.listWaitingForCompany = listWaitingForCompany;
const releaseDistributionRequest = (requestId) => ApiClient_1.apiClient.post(`/api/distribution-requests/${encodeURIComponent(requestId)}/release`);
exports.releaseDistributionRequest = releaseDistributionRequest;
